import React from 'react'
import {injectIntl} from 'react-intl'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

export default injectIntl(({intl, text, title, button, children, handleClose, handleConfirm}) =>
	<React.Fragment>
		<DialogTitle>
			{title ? title : intl.formatMessage({id: "app.confirm_delete_title"})}
		</DialogTitle>
		<DialogContent>
			{children}
			<DialogContentText>
				{text}
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={handleClose} color="primary">
				{intl.formatMessage({id: "app.confirm_cancel"})}
			</Button>
			<Button onClick={handleConfirm} variant="contained" color="secondary">
				{button ? button : intl.formatMessage({id: "app.confirm_delete"})}
			</Button>
		</DialogActions>
	</React.Fragment>
)
